import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { ArrowBackIos } from "@mui/icons-material";
import {
  AppBar,
  Box,
  IconButton,
  Toolbar,
  Skeleton,
  Container,
} from "@mui/material";

import ArtistLogo from "@/fragments/ArtistLogo";
import { useMedia } from "@/services/hooks";
import { SubscribedProvider } from "@/providers/Subscribed";
import MediaCard from "@/components/MediaCard";
import MainAppBar from "@/components/MainAppBar";
export default function Media() {
  const [contentKey, setContentKey] = useState(null);

  const [didScroll, setDidScroll] = useState(false);
  const { artistKey } = useParams();
  const contentRef = useRef(null);

  const { data: artistContent, isLoading } = useMedia(artistKey);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    setContentKey(params.get("contentKey"));
  }, []);

  const scrollToContent = async () => {
    if (!contentRef.current) return;
    contentRef.current.scrollIntoView();
    window.scrollBy(0, -60);

    setDidScroll(true);
  };

  useEffect(() => {
    if (contentKey) {
      scrollToContent();
    }
  }, [contentKey, artistContent]);

  return (
    <SubscribedProvider artistKey={artistKey}>
      <Container maxWidth="sm" sx={{ mt: 10 }} disableGutters>
        {/* <MainAppBar /> */}
        <PageAppBar />

        {isLoading && (
          <Box
            sx={{
              position: "fixed",
              top: 65,
              background: "rgba(19,19,19,1)",
              width: "100%",
              zIndex: 100,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              maxWidth: "600px",
            }}
          >
            <LoadingCard />
            <LoadingCard />
          </Box>
        )}

        <Box id="main-feed">
          <Box style={{ marginBottom: "100px" }}>
            {artistContent?.map((content, index) => (
              <Box
                key={content.key}
                ref={content.key === contentKey ? contentRef : null}
              >
                <MediaCard content={content} didScroll={didScroll} />
              </Box>
            ))}
          </Box>
          {!isLoading && artistContent.length === 0 && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: 4,
                mt: 4,
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  fontSize: "1.5rem",
                  fontWeight: 500,
                  color: "text.secondary",
                }}
              >
                No media found
              </Box>
            </Box>
          )}
        </Box>
        {/* <BottomTabs /> */}
      </Container>
    </SubscribedProvider>
  );
}

function PageAppBar() {
  const navigate = useNavigate();

  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{ background: "rgba(19,19,19,.9)" }}
    >
      <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
        <Box>
          <IconButton onClick={() => navigate(-1)}>
            <ArrowBackIos />
          </IconButton>
        </Box>

        {/* <AppLogo /> */}
        <ArtistLogo />
        <Box style={{ width: "40px" }} />
      </Toolbar>
    </AppBar>
  );
}

function LoadingCard() {
  return (
    <Box sx={{ mb: 10, width: "100%" }}>
      <Box
        sx={{
          mb: 1,
          p: 1,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Skeleton variant="circular" width={30} height={30} />
        <Skeleton
          variant="rectangular"
          width="45%"
          height={10}
          style={{ borderRadius: "5px" }}
        />
      </Box>
      <Skeleton variant="rectangular" width="100%" height={430} />
      <Skeleton
        variant="rectangular"
        width="80%"
        height={10}
        sx={{ mx: 1, my: 2 }}
        style={{ borderRadius: "5px" }}
      />
      <Skeleton
        variant="rectangular"
        width="45%"
        height={10}
        sx={{ m: 1 }}
        style={{ borderRadius: "5px" }}
      />
    </Box>
  );
}
